export const selectAllPlans = (state: RootState) => state.plans.allPlans;
export const selectPromo = (state: RootState) => state.plans.promo;
